import React from 'react'
import { Link as RRLink } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  link: {
    textDecoration: 'none',
    color: 'black',
  },
})

const Link = ({ classes, ...props }) => {
  return (
    <RRLink className={classes.link} {...props} />
  )
}

export default withStyles(styles)(Link)